export const queueMacrotask = (task: (arg?: any) => void) => {
  return window.setTimeout(task, 0);
};
